module.exports = {
  welcome: {
    product_name: "NextMind",
    // product_slogan: "Perform like a legend.Stand out with style!",
    product_slogan: "Perform like a legend.",
    product_slogan_two: "Stand out with style!",
    product_feature_introducation_one: "Enter a sentence, choose your direction, get a high-quality PPT",
    product_feature_introducation_two: "Import a script to get a logically structured and detail-rich PPT",
    product_feature_introducation_three: "Insert a slide, pick a template — add the finishing touch with style",
    start_btn_txt: "Get Started",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    welcome_agree_terms_of_service: "I have read and agree to the Terms of Service and Privacy Policy",
    copy_right: "NextMind / NEXTMIND, LLC © 2025-2026. All rights reserved.",
    register_trial_description:"Register now to get 200 free AI credits (valid for 30 days) and enjoy all Pro features.",
  },
  welcome_carousel_slides: {
    slide_1_title: "Data Security",
    slide_1_description: "Enterprise-grade protection to keep your data safe and reliable at all times.",
    slide_2_title: "Intelligent Documents",
    slide_2_description: "Leverage AI technology to make your document workflows smarter and more efficient.",
    slide_3_title: "Seamless Creation",
    slide_3_description: "An integrated Office-style creation experience that boosts your overall productivity."
  },
  login: {
    title_welcome: "Welcome to NextMind",
    title_logout: "Log Out",
    required_remind_text:'Username or password cannot be empty.',
  },
  signup:{
    txt_signup_des: "Pls sign up for an account",
    txt_btn_signup:"Sign Up",
    txt_btn_go_signup:"Sign Up",
    txt_btn_go_signin:"Log In",
    input_placeholer_account_email:"Email",
    input_placeholer_account_mobile:"Mobile",
    input_placeholer_verify_code:"Enter code",
    txt_btn_get_verify_code:"Get Code",
    input_placeholer_account_name:"Account Name",
    input_placeholder_password:"Password",
    input_placeholder_repeat_password:"Confirm Password",
    verification_code_send_success:"Sent successfully.",
    signup_success_show_user_msg:"Congratulations, you can login now to start exploring!",
    signup_failed_show_user_msg:"An error occurred with your account. Please contact support or try registering again."
  },
  valiad:{
    show_user_msg_account_required:"Pls enter your account.",
    require_valida:"This field cannot be empty.",
    email_valida:"Invalid email format",
    mobile_valida:"Invalid phone number format",
    email_mobile_valida:"Invalid account fromat",
    password_valida:"Password must be at least 8 characters long and include uppercase letters, lowercase letters, numbers, and special characters.",
    password_and_repeat_password_match_valida:"Passwords do not match"
  },
  main: {
    title_menu_gpt: "NextMind",
    title_menu_template: "Template",
    title_menu_canvas: "Canvas",
    title_menu_account: "Account",
    title_menu_gallary: "Gallery",
    logout_drawer: {
      title: "Log Out",
      cancel_btn_txt: "Cancel",
      confirm_btn_txt: "Log Out",
      text_logout_remind: "Are you sure to log out?",
      text_logout_remind_two: "You can log in again at any time.",
      user: {
        name: "User",
        email: "<EMAIL>",
        avatar: "https://avatars.githubusercontent.com/u/1011681?v=4"
      },
    }
  },
  gpt: {
    text_placeholder_inputbar: "Ask something...",
    text_gpt_optimize: "Optimizing your question",
    text_gpt_generating: "Generating content",
    text_gpt_generate_success: "Generation successful",
    text_gpt_generate_fail: "Generation failed",
    text_gpt_noanswer: "GPT has no answer.",
    text_gpt_preprompts_title: "You might also ask:",
    text_gpt_answer_thumbup: "Helpful",
    text_gpt_answer_thumbdown: "Not Helpful",
    text_gpt_answer_scored: "Rated",
  },
  ppt_addin: {
    process: {
      text_ppt_generating_content: "Generating content...",
      text_ppt_generating_content_failed: "Content generation failed",
      text_ppt_generating_content_parsing: "Parsing content...",
      text_ppt_generating_text: "Generating content for slide {0}",
      text_ppt_make_slide:'Creating slide {0}/{1}',
      text_ppt_generating_total:"Total {0} slides generated",
      text_ppt_generating_image_prompt: "Generating image description...",
      text_ppt_generating_image: "Generating image...",
      text_ppt_generating_image_download: "Downloading and insert image...",
      text_ppt_generating_image_success:"Completed! Inserted an image on slide {0}.",
      text_ppt_generating_expand_content: "Expanding slide content...",
      text_ppt_generating_expand_content_success:"The operation has been completed, adding {1} words on page {0}.",
      text_ppt_generating_extract_content:"Extracting key content…",
      text_ppt_generating_extract_content_success:"Completed! Removed {1} words from slide {0}.",
      text_ppt_generation_update_slide: "Updating slide...",
      text_ppt_generating_icon: "Generating icon...",
      text_ppt_generating_icon_success:"Completed! {0} icons generated and repositioned.",
      text_ppt_generating_ppt_onepage: "Generating slide...",
      text_ppt_generating_ppt_onepage_success:"Slide generated successfully.",
      text_blink_translate:'Translating',
      text_blink_think:'Thinking',
      text_blink_intent_recognition:'Recognizing intent', 
      text_blink_intent_recognition_success:'Intent recognized successfully', 
      text_blink_update_slides_content:'Learning latest content', 
      text_blink_prompt_recognition:'Recognizing prompt', 
      text_blink_response_streaming:'Receiving AI response', 
      text_blink_generate_content:'Generating Content',
      text_blink_image_generate_key_elements:'Extracting key elements and scenarios',
      text_blink_image_generate_prompt:'Constructing image prompts intelligently',
      text_blink_image_generate:'Generating image',
      text_blink_enchance_prompt:'Prompt optimization',
      text_blink_slides_build:'Generating Slides',
      // text_msg_complete_translate:'Translation completed, Click to view details. <br/> More features coming soon!',
      // text_msg_complete_onepageslide_generate:'Single-slide Slides created! Click to view details.<br/> More features coming soon!',
      // text_msg_complete_allSlides_generate:'Slides created! Click to view details.<br/> More features coming soon!',
      text_msg_complete_translate:'Translation completed, Click to view details. \\n More features coming soon!',
      text_msg_complete_onepageslide_generate:'Single-slide Slides created! Click to view details.\\n More features coming soon!',
      text_msg_complete_allSlides_generate:'Slides created! Click to view details.\\n More features coming soon!',
    },
    dialog: {
      translate_all_title:'Full text translation details',
      onepageslide_title: 'Content details'
    },
    message: {
      text_message_nocontent_process: "There is no content to process.",
      text_message_not_select_slide: "You did not select a slide.",
      text_message_input_placeholder: "Please describe your idea or request...",
      text_message_press_key: "Press '/' or '、' to open AI command menu",
      text_userlog_format_task: "Current task: ",
      text_userlog_format_current_page: "Page {0}: ",
      text_userlog_format_reference_content: "Reference content: ",
      text_userlog_format_optimized_content: "Optimized content: ",
      text_userlog_format_your_description: "Your description: ",
    },
  },
  gallary: {
    ui: {
      input_form_keywords_label: "关键词",
      input_form_keywords_placeholder: "图标名称，例如：发送按钮",
      input_form_category_label: "分类",
      input_form_category_selected: "选择分类",
      input_form_style_label: "风格",
      input_form_style_selected: "选择风格",
      input_form_style_nodata_text: "先选择分类",
      input_form_bg_color_label: "背景",
      input_form_bg_color_Placeholder: "选择背景色",
      input_form_button_generate: "生成",
    },
  },
  ppt_add_in_main: {
    login:"Login",
    login_home_title: "Welcome to NextMind",
    login_home_account_hint: "Username",
    login_home_account_empty: "Please enter your username",
    login_home_password_hint: "Password",
    login_home_password_empty: "Please enter your password",
    paramter_error:"Office file properties are abnormal. Please close Office or log out of NextMind and log in again!",
    text_content_empty: "Please enter content",
    server_general_error_message: "The AI server is busy. Please try again later~",
    text_copy_success: "Copied successfully!",
    text_like: "Thank you for your support! We will keep improving.",
    logout_time_remind: "Press again to log out of the current account.",
    input_word_count_limit: "Sorry, maximum input length is 2000 characters.",
    user_settings: "Image Style",
    subscription_settings: "Subscriptionis",
    save: "Save",
    confirm: "Save",
    subtitle_mode:' Mode：',
    business_style: "Business",
    business_style_desc: "Professional",
    free_style: "Free",
    free_style_desc: "Creative",
    subtitle_style:' Style：',
    style_mode_ai: "AI Style",
    style_mode_human: "Select Style",
    art_style_overview: "All styles Overview",
    img_style_select_title:"Select Mode/Style",
    img_style_selected_title:'Style: ',
    img_style_selected_AI:'AI Select Style',
    img_mode_select_remind_txt:'* Smart image styling guided by mode selection',
    txt_remind_pls_select_image_style: 'Please select an image style',
    template_select_title:"Select Template",
    template_select_font_type:"Select Font",
    template_select_shape_color:"Select MainThemeColor",
    input_bar_placeholder_after_upload_file_first:"Generate base file：[ ",
    input_bar_placeholder_after_upload_file_second:" ], Continue typing or send",
    input_bar_placeholder_uploading_first:"Uploading file：[ ",
    input_bar_placeholder_uploading_second:" ]",
    input_bar_placeholder_upload_file_first:"File[ ",
    input_bar_placeholder_upload_file_second:" ]to Slides",
    btn_select_file:'File',
    btn_select_template_default:'Templates',
    btn_select_template:'Selected',
    btn_clear_select_template:'Clear',
    msg_pls_select_template:'Pls select template',
    msg_pls_select_file:'Pls select file',
    msg_pls_select_sys_template:'Pls select default template',
    template_select_tab_name_semantic:'Semantic',
    template_select_tab_name_sys:'Visual',
    template_select_tab_name_ent:'Enterprise',
    template_select_tab_name_whole:'Enterprise',
    uniform_operation_loading_default:'Loading...',
    msg_something_error:'Something error, pls try again later！',
    loading_txt_uniform_operation_begin:'Start...',
    loading_txt_uniform_operation:'Complete: ',
    txt_title_enchance_prompt_list:"Choose more prompts to get satisfactory results:",
    txt_remiind_enchance_prompt_confirm:"Confirm to use selected Prompt : ",
    txt_remind_pls_select_template_whole_task_type: 'Please select the whole template at enterprise template task',
    txt_remind_pls_select_template_onepage_task_type: 'please select the onepage template at onepage task',
  },
  home: {
    text_general_placeholder:"Generate Content with NextMind",
    text_general_warring_text:"*AI-generated content may be incorrect",
    text_general_warring_ppt_init_error:"Slides init error. Right-click to refresh.",
    server_error_message: "Service optimizing. Try later~",
    server_error_but_success_message: "Service optimizing. Try later~",
    generating_sending_remind_message: "Being generated, please wait ~",
    generating_sending_remind_message_whole_template: "To ensure the final effect, do not operate yet.",
    generating_sending_remind_message_whole_template_process: 'Total{0}Pages, Current no.{1}',
    llm_service_error: "LLM service unavailable.",
    content_empty:"Please enter text.",
    text_content_empty_unsupport_shape_type: "Not supported yet, coming soon!",
    login_status_error: "Session expired, please log in again!",
    action_header_menu:"Start",
    license_error_description_901: "No subscription available",
    license_error_description_902: "No subscription, contact admin.",
    license_error_description_903: "Subscription unavailable, contact admin.",
    license_error_description_904: "Insufficient balance, contact admin.",
  },
  chat: {
    chat_document_init_loading: "NextMind Learning...",
    chat_log_init_loading: "Loading chat history...",
    chat_log_update_faile: "NextMind Answering based on previous content",
    message_action_insert: "Insert",
    message_action_go_to_optimize: "Optimize",
    message_action_outline_optimize: "Optimize",
    message_action_change_template_regenerate: "Change Template",
    message_action_go_to_details: "Details",
    message_action_outline_ppt: "Gen Slides",
    default_input_placeholder: "Input prompt or type '/' for menus",
    onepage_slide_input_placeholder: "Select template, upload file, and describe your topic or scenario",
    create_slide_input_placeholder: "Describe your topic or scenario",
    optimize_slide_input_placeholder: "Please describe your request, e.g., ‘Help me enrich the content.’",
    input_bar_ai_action_more: "Actions：",
    input_bar_ai_action_title: "Actions: ",
    input_bar_user_select_action_title: "Selected:",
    input_bar_suggest_action_abstract: "Abstract",
    input_bar_suggest_action_summary: "Summarize",
    text_slide_outline_title:"Optimize Outline",
    text_prompt_generate_base_title_pageindex: 'The current Slides page number is: Page ',
    text_prompt_generate_base_title_new_slide_title: 'The new page title and contents are:',
    text_prompt_change_template_regenerate: 'Change the template and regenerate the content',
  },
  optimize_home: {
    home_title: "Optimization Workbench",
    btn_text_replace: "Replace",
    btn_text_insert: "Insert",
    btn_text_regenerate: "Rewrite",
    btn_text_adjust: "Adjust",
    text_finish_remind_text_optimize: "*AI-generated Content.",
    text_warning_select_no_shape:"Select target area",
    text_warning_ai:"*AI-generated content may be incorrect",
    btn_text_outline_to_slide: "Gen Slides",
    btn_text_outline_optimize: "Optimize",
    text_input_outline_title: "How to adjust the outline?",
    text_input_placeholder_outline: "Enter requirements or click below to generate.",
  },
  dialog: {
    input_content_not_null: "Describe your requirements",
    error_message: "Something error, please try again later~"
  },
  welcomeMessageCard: {
    tittle: "Get started:",
    action_create_whole_template_slides: "Enterprise Slides...     ",
    action_create_whole_slides: "OneSentence Full Slides...     ",
    action_create_one_page_slide: "Generate Slide...     ",
    action_create_slide_outline: "Outline...     ",
    action_create_ppt_from_file: "Start from File...     ",
    actoin_optimize_current_page_slide: "Adjust Current Slide...     "
  },
  ppt_select_state: {
    select_no_slide: "No slide selected",
    select_one_slide: "Select Single Slide",
    select_mluti_slide: "Select Multiple Slides",
    select_no_shape: "No shape selected",
    select_one_shape: "Single shape selected",
    select_one_shape_img: "Single image shape selected",
    select_one_shape_txt: "Single text shape selected",
    select_mluti_shapes: "Multiple shapes selected",
    select_mluti_img_shapes: "Multiple image shapes selected",
    select_mluti_txt_shapes: "Multiple text shapes selected",
  },
  ppt_menus: {
    ppt_menus_full_template_ppt:"Template Slides",
    ppt_menus_full_ppt:"Full Deck",
    ppt_menus_template_whole_ppt:"Full Deck-Common Template",
    ppt_menus_template:"Template",
    ppt_menus_bp_classic:"BP-Classic",
    ppt_menus_bp_innovative:"BP-Innovative",
    ppt_menus_one_page:"Slide",
    ppt_menus_one_page_consulat:"Consulting Canvas",
    ppt_menus_business_canvas:"Business Model",
    ppt_menus_market_analysis:"TAM",
    ppt_menus_crossing_chasm:"Cross the Chasm",
    ppt_menus_ppt_outline:"Outline",
    ppt_menus_ppt_translate_all:"Translate All",
    ppt_menus_ppt_translate_all_en:"to English",
    ppt_menus_ppt_translate_all_zh:"to Chinese",
    ppt_menus_ppt_uniform_style:"Style",
    ppt_menus_ppt_uniform_style_font:"Font Style",
    ppt_menus_ppt_uniform_style_color:"Theme Color",
    ppt_menus_refine_outline:"Refine Outline",
    ppt_menus_outline_to_ppt:"Outline to Slides",
    ppt_menus_file_to_ppt:"File to Slides",
  },
  ppt_menus_length: {
    menu_title:"Length",
    menus_length_short:"Brief",
    menus_length_normal:"Standard",
    menus_length_rich:"Extended",
  },
  ppt_menus_tone: {
    menu_title:"Tone",
    menus_tone_expert:"Expert",
    menus_tone_normal:"Normal",
    menus_tone_casual:"Casual",
  },
  ppt_action_type: {
    suggest_action_title:"Suggest Title",
    suggest_action_consolidate:"Merge Text",
    suggest_action_optimize:"Rephrase",
    suggest_action_smart_img:"Add Image",
    suggest_action_another_img:"More Image",
    suggest_action_trans_zh_to_en:"Trans to Eng",
    suggest_action_smart_replace_img:"Smart Img Replace",
    suggest_action_generate_ppt_outline: "Generate a Slides based on the outline",
    suggest_action_enrich_one_page_content:"Enrich",
    suggest_action_generate_enrich_one_page_content:"Auto Content",
  },
  ppt_img_style: {
    img_msg_btn:'Style: ',
    img_style_surreal:"Surreal",
    img_style_cyberpunk:"Cyberpunk",
    img_style_oil:"Oil painting",
    img_style_ink:"Ink painting",
    img_style_illustration:"Illustration",
    img_style_stickers:"Stickers",
    img_style_impressionism:"Impressionism",
    img_style_post_impressionism:"Post-Impressionism",
    img_style_symbolism:"Symbolism",
    img_style_pop_art:"Pop art",
    img_style_minimalism:"minimalism",
    img_style_conceptual_art:"Conceptual art",
    img_style_contemporary_art:"Contemporary art",
    img_style_baroque:"Baroque",
    img_style_rococo:"Rococo",
    img_style_neoclassicism:"Neoclassicism",
    img_style_romanticism:"Romanticism",
    img_style_realism:"realism",
    img_style_expressionism:"Expressionism",
    img_style_cubism:"Cubism",
    img_style_surrealism:"Surrealism",
    img_style_abstract_expressionism:"Abstract Expressionism",
    img_style_photorealism:"Photorealism",
    img_style_contemporary_documentary_photography:"Documentary Photography",
  },
  ppt_img_mode: {
    img_mode_business:'Business',
    img_mode_free:"Free",
  },
  subscription: {
    loading_txt: "Loading...",
    go_to_office_web_txt: "Official Website",
    home_title_txt: "Subscription",
    home_tab_my_subscription_txt: "History",
    home_tab_buy_subscription_txt: "Buy",
    home_credits_info_total: "Total",
    home_credits_info_used: "Used",
    home_credits_info_balance: "Balance",

    history_list_title: "History List",
    history_list_item_status_active: "Active",
    history_list_item_status_expire: "Expire",
    history_list_item_status_pending: "Pending",

    loading_product_page_home_txt:"Product Info Loading...",
    btn_product_page_card_buy:"Buy",

    checkout_page_payment_method_title: "Payment Method",
    checkout_page_payment_method_qr_code: "QR Code",
    checkout_page_payment_method_coming_soon: "Coming Soon",
    checkout_page_payment_Wechat: "Wechat",
    checkout_page_payment_Alipay: "Alipay",
    checkout_page_payment_Stripe: "Card-Stripe",
    checkout_page_payment_Bank: "Bank",

    checkout_page_payment_amount: "Amount",

    checkout_page_payment_check_subscription_info: "Pay Details",

    checkout_page_payment_remind_txt: "Confirm details to pay!",
    checkout_page_payment_btn_pay: "Pay",
    
    checkout_page_payment_order_loading_txt: "Create Order...",

    pay_page_title_qr_code: "QR Code",
    pay_page_title_timer: "Pay Now: ",
    pay_page_title_pay_remind_txt_wechat: "Secure payment via WeChat Pay",
    pay_page_title_pay_remind_txt_alipay: "Secure payment via Alipay",

    pay_page_title_pay_time_out: "Payment expired",
    pay_page_title_pay_time_out_notice: "Payment timeout occurred. Please place your order again.",

    pay_succeed_page_title: "Payment Successful!",
    pay_succeed_page_thanks: "Thank you for your purchase. Your subscription is now active.",
    pay_succeed_page_stripe_thanks: "Thank you for your purchase. Your subscription is now active. Please return to PowerPoint to continue using.",
    pay_succeed_page_btn_close_current_page: "Close Page",
    pay_succeed_page_btn_go_to_subscription: "View My Subscription",
    
    download_app_btn_txt: "Install Now",
    logout: "Log Out",
    logout_confirm: "Confirm Log Out?"
  }
};